import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyBio from './components/WhyBio';
import Projects from './components/Projects';
import WhyChoose from './components/WhyChoose';
import Presence from './components/Presence';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import { Toaster } from './components/ui/toaster';

import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import CareerPage from './pages/CareerPage';
import CSRPage from './pages/CSRPage';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import { useNavigate } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);

    const pageMeta = {
      '/': ['Indian Energreen | Sustainable Energy Solutions', 'Indian Energreen delivers compressed biogas, biofuels, solar energy and EV charging solutions for a greener India.'],
      '/about': ['About Indian Energreen | Clean Energy Partner', 'Learn about Indian Energreen and our mission to build a cleaner, energy-independent India.'],
      '/services': ['Sustainable Energy Services | Indian Energreen', 'Explore Indian Energreen solutions for compressed biogas, biofuels, solar energy, green hydrogen and EV charging.'],
      '/projects': ['Clean Energy Projects | Indian Energreen', 'Discover Indian Energreen clean-energy projects across India.'],
      '/gallery': ['Gallery | Indian Energreen', 'Explore the Indian Energreen gallery of sustainable energy initiatives and projects.'],
      '/career': ['Careers | Indian Energreen', 'Explore career opportunities at Indian Energreen.'],
      '/csr': ['CSR | Indian Energreen', 'Learn how Indian Energreen supports sustainable communities through our CSR initiatives.'],
      '/contact': ['Contact Indian Energreen | Karnal Headquarters', 'Contact Indian Energreen at our Karnal headquarters for sustainable energy solutions.'],
    };
    const [title, description] = pageMeta[pathname] || pageMeta['/'];
    const pageUrl = `https://indianenergreen.com${pathname}`;
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('#canonical-url')?.setAttribute('href', pageUrl);
    document.querySelector('#og-url')?.setAttribute('content', pageUrl);
  }, [pathname]);
  return null;
};

const Home = () => {
  const navigate = useNavigate();
  const goQuote = () => navigate('/contact');
  return (
    <main>
      <Hero onQuote={goQuote} />
      <About />
      <Services />
      <WhyBio />
      <Projects />
      <WhyChoose />
      <Presence />
      <Testimonials />
      <CTA onQuote={goQuote} />
      <Contact />
    </main>
  );
};

const Layout = ({ children }) => (
  <div className="min-h-screen bg-white">
    <TopBar />
    <Navbar />
    {children}
    <Footer />
    <WhatsAppFloat />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:id" element={<ServicesPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/career" element={<CareerPage />} />
          <Route path="/csr" element={<CSRPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
